import { FileSummary } from "@oldDashboard/legacyModels/fileSummary.model";
import { FileSummarySerializer } from "@oldDashboard/legacyModels/serializers/fileSummarySerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandFileSummary {

    async run(launchSelected:String) {
        const path = `launch-last-data-file-summary/?launch_id=${launchSelected}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.data.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : FileSummary[] {
        const serializer = new FileSummarySerializer();
        return serializer.deserializeList(data);
    }
}

